export const isInViewport = (element) => {
  if (typeof window === 'undefined') return false;

  const rect = element.getBoundingClientRect();
  // temp, 113 is the header height, TODO: fins a better way to solve for this
  return (
    rect.top >= 113 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const toSnakeCase = (kebabCase: string | undefined) => {
  return kebabCase?.replace('-', '_');
};

export const getPathName = (url: string) => new URL(url).pathname;

export const PAGE_TITLE = `Expedia Group Developer Hub`;

export const removeHubNameFromPath = (path: string) => {
  return path.split('/').slice(2).join('/');
};
